// removed by extract-text-webpack-plugin
module.exports = {"Popup":"Popup__Popup___Ja7ZC","Content":"Popup__Content___1IrmW","fadein":"Popup__fadein___PlNK4","Header":"Popup__Header___p4TFJ","Bold":"Popup__Bold___2YxJV","Count":"Popup__Count___1Zm8Z","Close":"Popup__Close___2HlWO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Building/Main/Popup/Popup.scss
// module id = 1382
// module chunks = 0